export enum Permissions {
    User = 0,
    Administrator = 1,
    Developer = 2,
}

export const getPermissionKeys = () => {
    return Object.keys(Permissions).filter(key => isNaN(Number(key)));
}